import React from 'react';
import PropTypes from 'prop-types';

import { isOptionMaterial } from 'commons/constants';
import ProductOption from './ProductOption';

const ProductDescription = ({ product, removeExtraCushion }) => (
  <>
    {product.pickLater && (
      <div
        className="text-xs flex items-center relative py-0 text-gray"
        key="decideMaterialLater"
      >
        Material: Decide Later
      </div>
    )}
    {product.options.map(option => {
      if (
        (product.pickLater && isOptionMaterial[option.optionTypeId]) ||
        option.optionTypeId === 19
      ) {
        // don't show wood stain options
        return null;
      }

      return (
        <div
          className="text-xs flex items-center relative py-0 text-gray"
          key={option.id}
        >
          <ProductOption
            {...option}
            product={product}
            removeExtraCushion={removeExtraCushion}
          />
        </div>
      );
    })}
  </>
);

ProductDescription.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    pickLater: PropTypes.bool,
  }),
  removeExtraCushion: PropTypes.func,
};

export default ProductDescription;
